module.exports = __webpack_public_path__ + "img/train-11.266cca38.jpg";